import React from 'react'

function About() {
    return (
        <div>
            <React.Fragment>
                <h3>
                    About page.
                </h3>
                <p>Proident proident reprehenderit et reprehenderit nisi aute labore voluptate in. Dolor aute enim ea anim culpa elit qui est nisi. Ex pariatur cillum deserunt Lorem mollit ex.</p>  
            </React.Fragment>
        </div>
    )
}

export default About;
